const AppCuesHook = {
  mounted() {
    this.handleEvent("appcues_email_fetched", () => {
      window.Appcues?.track("Email Fetched")
    })

    this.handleEvent("appcues_phone_fetched", () => {
      window.Appcues?.track("Phone Fetched")
    })

    this.handleEvent("appcues_email_connection_attempt", () => {
      window.Appcues?.track("Email Connection Attempted")
    })
  },
}

export default AppCuesHook
